import React from 'react';
import { Route, Switch } from 'react-router-dom';
// import { ClaimList } from './claims/ClaimList';
// import { ClaimCreate } from './claims/ClaimCreate';
// import { SubjectList } from './subjects/SubjectList';
// import { DiaryList } from './diaries/DiaryList';
import { Payment } from './actions/Payment';
import { ClaimDDUploadOverview } from './addons/ClaimDDUploadOverview';



export const ClaimRouter = () => {
  return (
    <Switch>      
      {/* <Route exact path="/claims" component={ClaimList} />       */}
      <Route path="/claim/action/payment" component={Payment} />      
      <Route path="/claim/action/ddoverview" component={ClaimDDUploadOverview} />      

      {/* <Route path="/claims/create" component={ClaimCreate} />      
      <Route exact path="/subjects" component={SubjectList} />            
      <Route exact path="/dairies" component={DiaryList} />                   */}
      
    </Switch>
  );
};
